/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../Common/checkbox';
import useDropDownOpen from '../../hooks/useDropDownOpen';

const SprintFilter = ({ checkedOptions, onFilterClick, filter, options }) => {
  const [filterValue, setFilterValue] = useState('');

  const { open, setOpen } = useDropDownOpen();

  const filterOptions = (event) => {
    const input = event.target.value;
    setFilterValue(input);
  };

  const clearInput = () => {
    setFilterValue('');
  };

  const filteredOptions =
    filterValue.length > 0
      ? options.filter((option) =>
          option.short_name.toLowerCase().includes(filterValue)
        )
      : options;

  const handleButtonClick = () => {
    setOpen((prevOpen) => !prevOpen);
    onFilterClick();
  };

  return (
    <div id="sprintFilter" className="dropdown">
      <button
        type="button"
        id="sprintFilterLabel"
        className="btn btn-link vrs-filter"
        onClick={handleButtonClick}
      >
        Sprint
      </button>
      {open && (
        <ul className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <form>
            <li>
              {options.length > 5 && (
                <input
                  type="text"
                  name="filter"
                  value={filterValue}
                  onChange={filterOptions}
                />
              )}
              {filterValue.length > 0 && (
                <button
                  type="button"
                  className="btn btn-link red right"
                  title="Clear Input"
                  onClick={clearInput}
                >
                  X
                </button>
              )}
            </li>
            <li className="options">
              <CheckBox
                label="Unassigned"
                value="unassigned"
                checked={checkedOptions.includes('unassigned')}
                handleCheckboxChange={filter}
              />
            </li>
            {filteredOptions.map((option) => (
              <li className="options" key={option.id}>
                <CheckBox
                  label={option.short_name}
                  value={option.id}
                  checked={checkedOptions.includes(option.id)}
                  handleCheckboxChange={filter}
                />
              </li>
            ))}
            <li>
              <button
                type="button"
                className="btn btn-xs btn-primary"
                onClick={filter}
              >
                All
              </button>
            </li>
          </form>
        </ul>
      )}
    </div>
  );
};

SprintFilter.propTypes = {
  options: PropTypes.array,
  checkedOptions: PropTypes.array,
  filter: PropTypes.func
};

SprintFilter.defaultProps = {
  options: [],
  checkedOptions: []
};

export default SprintFilter;
